import React, { memo } from 'react';
import NotificationMenu from './NotificationMenu';
import useTopPanel from 'hooks/useTopPanel';
import LanguageMenu from './LanguageMenu';
import DailyCurrency from './DailyCurrency';
import CallsHistory from './calls-history/CallsHistory';
import Navigators from './Navigators';
import User from './User';
import Calculator from './calculator';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

const TopPanel = () => {
  const { component } = useTopPanel();

  return (
    <div className='with-max-width h-16 border-b border-b-[#E5E9EB] bg-[#F8F9FB]'>
      <div
        id='top-panel'
        className='top-panel-wrapper py-4 px-4 flex items-center justify-between z-[10] h-16 with-max-width'
      >
        <div className='top-panel-tools flex items-center justify-between w-full mx-2 gap-[10px]'>
          <Navigators />
          {component}
          <div className='flex items-center gap-2 ml-auto'>
            <div>
              <DailyCurrency />
            </div>
            <div>
              <CallsHistory />
            </div>
            <div>
              <LanguageMenu />
            </div>
            <div>
              <NotificationMenu />
            </div>
            <div>
              <Link className='no-underline' to='/admin/hr'>
                <Button
                  variant='base'
                  size='small'
                  sx={{ padding: '6px 12px' }}
                >
                  <i className='bi bi-eye' />
                </Button>
              </Link>
            </div>
            <div>
              <Calculator />
            </div>
            <div>
              <User />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(TopPanel);
